<template>
    <div class="profile-edit">
        <rq-banner class="mb-1"
            message="Please correct errors."
            variant="error"
            icon="fas fa-exclamation-triangle"
            :visible="!isValid"
        />
        <rq-page-section :title="title" headerSize="lg" borderless>
            <profile-info
                ref="record"
                v-model:info="record"
                v-model:is-valid="isValid"
                v-if="isDataLoaded"
            />
        </rq-page-section>
    </div>
</template>
<script>
import ProfileInfo from "./ProfileInfo";
import { UserAccountProfile } from './models';
import phoneFormatter from "@/shared/mixins/phoneFormatter";
import dialogValidation from "@/shared/mixins/dialogValidation";

const defaultTitleBar = ""

export default {
    components: {
        ProfileInfo
    },
    mixins: [
        phoneFormatter,
        dialogValidation,
    ],
    props: {
        uniqueId: { default: null, type: String, required: true }
    },
    data: function() {
        return {
            record: new UserAccountProfile(),
            isValid: true,
            isDataLoaded: false
        }
    },
    computed: {
        title() {
            let titleName = _.get(this.record, "name", null) ? this.record.name : "";
            return titleName.length == 0 ? defaultTitleBar : titleName;
        },
    },
    created() {
        this.fetchRecord();
    },
    watch: {
        uniqueId: {
            handler: function(newValue, oldValue) {
                this.fetchRecord();
            },
            deep: true,
            immediate: false
        },
    },
    methods: {
        fetchRecord() {
            const self = this;
            self.isDataLoaded = false;
            if (_.isNullOrEmpty(self.uniqueId)) return;
            let promise = self.$api.UserAccountApi
                .getUserByUniqueId(self.uniqueId)
                .then(result => {
                    self.loadRecord(result);
                });
            self.$rqBusy.wait(promise);
        },
        loadRecord(result){
            this.record = new UserAccountProfile(result);
            this.originalRecord = _.clone(this.record);
            this.isDataLoaded = true;
        },
        modalSave() {
            return this.updateRecord();
        },
        updateRecord(args) {
            const self = this;
            let dto = _.clone(self.record);
            dto.mfaPhoneNumber = self.unformatPhone(dto.mfaPhoneNumber);
            dto.cellPhone = self.unformatPhone(dto.cellPhone);
            let changes = self.getAuditChanges(dto, self.originalRecord);
            var changesCount = _.get(changes, 'length', 0);
            if (changesCount == 0) {
                return Promise.resolve();
            }

            let promise = self.$api.UserAccountApi
                .updateUserProfile(self.uniqueId, dto)
                .then(result => {
                    self.$toast.success({ message: self.title + " Saved Successfully" });
                    return result;
                })
                .catch(error => {
                    self.$toast.error(`Failed to Update ${self.title}: ${error.message}`);
                });
            return self.$rqBusy.wait(promise);
        },
        validate() {
            this.$refs.record.validate();
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .profile-edit {
        & section.rq-section .rq-section-header .rq-section-title{
            max-width: 95%;
        }
        & .custom-checkbox.rq-profile-email {
            display: inline-block;
            padding-right: 10px;
        }
        & .rq-selectbox-container {
            display: inline-block;
        }
    }
</style>